import React from 'react';
import { MDText } from 'i18n-react';

import ProTable from 'Components/shared/ProTable/ProTable';
import VehicleExteriorGradeTag from 'Components/shared/VehicleExteriorGradeTag/VehicleExteriorGradeTag';

import { DESCENDING_VEHICLE_GRADES_RANK_ORDER } from '../../VehicleDetailsExteriorGrading.const';
import { EXTERIOR_GRADING_TABLE_CONFIG } from '../ExteriorGrading.helpers';
import LocalTexts from '../ExteriorGrading.texts';

import styles from './ExteriorGradingTable.module.scss';

const LocalT = new MDText(LocalTexts);

const tableProps = {
	'aria-label': 'exterior-grading-table',
	role: 'table',
};
const LEVEL_COLUMN_WIDTH = '21.5%';

export const ExteriorGradingTable = () => (
	<ProTable
		alternateRowHighlight="even"
		className={styles.exteriorGradingTable}
		colGroup={
			<colgroup>
				<col span={1} />
				<col
					span={3}
					style={{
						width: LEVEL_COLUMN_WIDTH,
					}}
				/>
			</colgroup>
		}
		containerClassName={styles.exteriorGradingTableContainer}
		tableProps={tableProps}
	>
		<tr>
			<th>
				<span>{LocalT.translate('labels.levels')}</span>
			</th>

			{DESCENDING_VEHICLE_GRADES_RANK_ORDER.map((grade) => (
				<th key={grade} aria-label={grade}>
					<VehicleExteriorGradeTag noBackground className={styles.exteriorGradeLabel} exteriorGrade={grade} />
				</th>
			))}
		</tr>

		{EXTERIOR_GRADING_TABLE_CONFIG.map((row) => (
			<tr key={row.label}>
				<td>{row.label}</td>
				{DESCENDING_VEHICLE_GRADES_RANK_ORDER.map((grade) => (
					<td key={grade}>{row[grade]}</td>
				))}
			</tr>
		))}
	</ProTable>
);
